import React from 'react';
import PropTypes from 'prop-types';
import fetchResourceById from 'components/hoc/fetchResourceById';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import { fetchMembershipSchedule } from 'store/actions/membership-schedules/fetchMembershipSchedules';
import MembershipScheduleShow from './MembershipScheduleShow';

const MembershipShowContainer = (props) => {
    const {
        data,
        history,
        id,
        resource,
        resourceFetchFailed,
        resourceFetchLoading,
    } = props;

    if (resourceFetchLoading) {
        return <LoadingCard />;
    }

    if (resourceFetchFailed) {
        return <ResourceNotFound />;
    }

    if (!data) {
        return null;
    }

    return (
        <MembershipScheduleShow
            history={ history }
            id={ id }
            record={ data }
            resource={ resource }
        />
    );
};

MembershipShowContainer.propTypes = {
    data: PropTypes.object,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resource: PropTypes.string.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
};

const fetchValues = {
    resource: 'membership-schedules',
    action: fetchMembershipSchedule,
};

export default fetchResourceById(fetchValues)(MembershipShowContainer);



// WEBPACK FOOTER //
// ./src/pages/membership-schedules/show/MembershipScheduleShowContainer.js